module.exports = __webpack_public_path__ + "assets/img/yi_index_dz_on.14f8890f.png";